import { SIGNATURE_LIMITS } from '@demandproai/shared';

const bytesToMb = (bytes) => Math.round((bytes / (1024 * 1024)) * 10) / 10;

const rulesListClasses = 'text-sm text-body list-disc pl-5 mb-0';

const SignatureRules = () => (
  <ul className={rulesListClasses}>
    <li>{`PNG only, up to ${bytesToMb(SIGNATURE_LIMITS.MAX_FILE_SIZE_BYTES)} MB.`}</li>
    <li>{`Dimensions between ${SIGNATURE_LIMITS.MIN_WIDTH_PX}x${SIGNATURE_LIMITS.MIN_HEIGHT_PX} and ${SIGNATURE_LIMITS.MAX_WIDTH_PX}x${SIGNATURE_LIMITS.MAX_HEIGHT_PX} pixels.`}</li>
    <li>Transparent background recommended.</li>
  </ul>
);

export default SignatureRules;
